import Phaser from 'phaser';

export class EffectSystem implements IEffectSystem {
  private sceneRef: Phaser.Scene;

  constructor(scene: Phaser.Scene) {
    this.sceneRef = scene;
  }

  spawnParticles(x: number, y: number, count: number, color: number = 0xffffff): void {
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count;
      const speed = 2 + Math.random() * 3;
      const particle = this.sceneRef.add.rectangle(
        x, y, 4, 4, color
      ).setScrollFactor(0);

      this.sceneRef.add.tween({
        targets: particle,
        x: x + Math.cos(angle) * speed * 30,
        y: y + Math.sin(angle) * speed * 30,
        alpha: 0,
        duration: 300,
        onComplete: () => particle.destroy(),
      });
    }
  }

  spawnFloatingText(x: number, y: number, text: string): void {
    const textObj = this.sceneRef.add.text(x, y, text, {
      fontSize: '12px',
      fontFamily: 'monospace',
      color: '#ffff00',
    }).setOrigin(0.5).setScrollFactor(0);

    this.sceneRef.add.tween({
      targets: textObj,
      y: y - 30,
      alpha: 0,
      duration: 500,
      onComplete: () => textObj.destroy(),
    });
  }

  screenShake(intensity: number, duration: number): void {
    this.sceneRef.cameras.main.shake(duration, intensity, true);
  }
}

export interface IEffectSystem {
  spawnParticles(x: number, y: number, count: number, color?: number): void;
  spawnFloatingText(x: number, y: number, text: string): void;
  screenShake(intensity: number, duration: number): void;
}
